import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";

const FormLabel = ({ label, required, className }) => {
  const appliedClassName = className ? className : "";

  return (
    <Form.Label className={appliedClassName}>
      {label} {required && <span className="text-danger">*</span>}
    </Form.Label>
  );
};

FormLabel.propTypes = {
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  className: PropTypes.string,
};

export default FormLabel;
